<script>
    import MoveAddressToProject from '../Projects/Addresses/MoveAddressToProject';

    export default {
        extends: MoveAddressToProject,
        data() {
            return {
                actionRouteName: 'api.sales-projects.move-selected-addresses.store',
                callbackRouteName: 'admin.sales-projects.addresses.show',
                modalInformation: 'Detta kommer att flytta adressen till det valda projektet. Adressen kommer att tas bort ur aktiv säljomgång samt att tilldelat team och säljare kopplas bort.',
            };
        },
    };
</script>
